import { debug } from "console";
import * as _ from "lodash";
import { Spread, Excel, wijmo } from "../../grapecity";
import { Util } from "../util";

/**
 * 必須項目カラムヘッダー
 */
export class RequiredColumnHeaderCellType extends Spread.Sheets.CellTypes.ColumnHeader {

    RADIUS: number;
    NORMAL_COLOR: string;

    /**/
    constructor() {
        super();
        this.RADIUS = 8;
        this.NORMAL_COLOR = "rgba(228,65,52,0.9)";
    }

    /**
     * @param ctx
     * @param value
     * @param x
     * @param y
     * @param width
     * @param height
     * @param style
     * @param context
     */
    paint(ctx: CanvasRenderingContext2D, value: any, x: number, y: number, width: number, height: number, style: Spread.Sheets.Style, context?: any) {
        super.paint(ctx, value, x, y, width, height, style, context);

        ////debugger;
        //// 出力テキストストの描画サイズ (TextMetrics) の取得
        //const metrics = ctx.measureText(value);
        //const textWidth = metrics.width
        //const textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent

        //let harfValueWidth = 0;
        //try {
        //    harfValueWidth = (textWidth / 2);
        //} catch (e) {
        //    null;
        //}

        //////paddhingとして5pxあたえる(足りない！テキストにtransformが掛かってるっぽい+15)
        //harfValueWidth += 20;

        //debugger;
        //ctx.save();
        //ctx.beginPath();

        //ctx.fillStyle = this.NORMAL_COLOR;
        //ctx.textAlign = 'center';
        //ctx.textBaseline = 'middle';
        //ctx.fillText("*", (x + width / 2) - harfValueWidth, (y + height / 2) + 5, width);

        //////ctx.fillStyle = this.NORMAL_COLOR;
        //////ctx.arc((x + width / 2) - harfValueWidth, y + height / 2, this.RADIUS / 2, 0, Math.PI * 2);
        //////ctx.fill();

        ////↓重要、全体的に描画がおかしくなります
        //ctx.restore();

    }
    /**
     * 
     * 
     * @param ctx
     * @param value
     * @param x
     * @param y
     * @param width
     * @param height
     * @param style
     * @param context
     */
    paintContent(ctx: CanvasRenderingContext2D, value: any, x: number, y: number, width: number, height: number, style: Spread.Sheets.Style, context?: any) {
        //debugger;
        //通常
        //super.paintContent(ctx, value, x, y, width, height, style, context);

        ////※対応が一番良い（Pending! 選択時、selectedなStykeが当たらない為）
        ////マニュアルにはないが下記が一番よさそう(問題ありそうならやめるか)
        //var text = {
        //    richText: [
        //        //{ text: "*  ", style: { foreColor: this.NORMAL_COLOR } },
        //        { text: "＊ ", style: { foreColor: this.NORMAL_COLOR } },
        //        //style入れると変な感じになる（スケーリングでおかしくなる）
        //        //{ text: value, style: style },
        //        //{ text: value },
        //        { text: value  },
        //    ]
        //}
        //super.paintContent(ctx, text, x, y, width, height, style, context);

        //※のみにする
        super.paintContent(ctx, "＊ " + value, x, y, width, height, style, context);



        //google　Sample
        //var text = {
        //        richText: [
        //            { text: "G", style: { font: "bold 36px Calibri", foreColor: "rgb(78,133,242)" } },
        //            { text: "o", style: { font: "bold 36px Calibri", foreColor: "rgb(228,65,52)" } },
        //            { text: "o", style: { font: "bold 36px Calibri", foreColor: "rgb(247,188,32)" } },
        //            { text: "g", style: { font: "bold 36px Calibri", foreColor: "rgb(78,133,242)" } },
        //            { text: "l", style: { font: "bold 36px Calibri", foreColor: "rgb(65,168,87)" } },
        //            { text: "e", style: { font: "bold 36px Calibri", foreColor: "rgb(228,65,52)" } }
        //        ]
        //    };
        //    super.paintContent(ctx, text, x, y, width, height, style, context);
        //}
    }

}



/**
  * 編集開始時日付format外の値の表示抑止
 * #2033 編集開始時日付format外の値の表示抑止
 * 日付形式（カレンダー選択可能）のセルで、年月日までの項目にも関わらず、
 * 特定のオペレーション(F2)で時分秒まで表示されることがある。
 * 
 * 原因：datePickerで取得した値は時刻にその時の時間が刻まれている（Truncされていない）
 *      その後編集MODEに入った時に、有効な値としてEditor上に入ってしまうようだ（セルのフォーマット無視、恐らくバグか考慮漏だろう）
 *      datePickerで取得した値が表示上の値と同じフォーマットで時刻が切り捨てられていれば、00:00:00は表示されない仕様らしい。。（いまいち動きがつかみづらい...）
 * @deprecated 結果、workSheetBase.valueChangedProcessで抑止した。
 */
export class DateTimeEditInterceptor extends Spread.Sheets.CellTypes.Text {

    /***/
    formatter;
    /**
     * 
     * @constructor
     *  @param formatter
     */
    constructor(formatter?) {
        super();
        this.formatter = formatter || "yyyy/MM/dd";
    }


    /**
     * 
     * @param editorContext
     * @param value
     */
    setEditorValue(editorContext, value) {
        //直接入力で数値を入れると通常とは違う変換方式（OADate形式？変換）でパースされ、(例：2→1900/01/01)
        //通常new Date等で日付に変換物と違う。
        //よってそれは仕様と受け止め。日付Likeではない値の変換は行わず、そのまま表示。
        //公式のサイトでも確認出来る（F:22セル）
        //https://demo.grapecity.com/spreadjs/demos/features/cells/drop-downs/date-time-picker/purejs
        if (Util.date.isDate(value)) {
            //日付にパース
            var dt = new Date(value);
            if (!isNaN(dt.getMilliseconds())) {
                //書式変換(時刻以下を切り捨て)
                value = wijmo.Globalize.format(dt, this.formatter);
            }
        }
        super.setEditorValue(editorContext, value);
    };
}


/**
 * 
 */
export class PasswordEditInterceptor extends Spread.Sheets.CellTypes.Text {

    /***/
    /**
     * 
     * @constructor
     *  @param formatter
     */
    constructor() {
        super();
    }

    //案①、編集コントロールをinput type=passwordにする
    ///**
    // * Creates a DOM element then returns it.
    // * @param {Object} context The context associated with the cell type. See the Remarks for more information.
    // * @returns {HTMLElement} Returns a DOM element.
    // */
    //createEditorElement(context?: any): HTMLElement {
    //    //let sp = super.createEditorElement(context);
    //    //let sp = $('<input type="password" autocomplete="off" style="border: none;outline: none;">').get(0);
    //    let sp = $('<input type="password" autocomplete="new-password" style="border: none;outline: none;">').get(0);

    //    return sp;
    //}


    //案②、編集時、強制的にパスワード文字数分の[*]に変換して表示する
    ///**
    // * 
    // * @param editorContext
    // * @param value
    // */
    setEditorValue(editorContext: HTMLElement, value) {
        //debugger;
        if (value && value.length > 0) {
            value = _.padStart('', value.length, '*'); //
        }
        super.setEditorValue(editorContext, value);
    }


    /**
     * Whether the editing value has changed.
     * @param {Object} oldValue Old editing value.
     * @param {Object} newValue New editing value.
     * @param {Object} context The context associated with the cell type. See the Remarks for more information.
     * @returns {boolean} <c>true</c> if oldValue equals newValue; otherwise, <c>false</c>.
     */
    isEditingValueChanged(oldValue: any, newValue: any, context?: any): boolean {
        let oldValueAst = oldValue;
        if (oldValue && oldValue.length > 0) {
            oldValueAst = _.padStart('', oldValue.length, '*'); //
        }
        let sp = false;
        if (oldValueAst == newValue) {
            //元の******文字列（数）と同じだったら変更無しとみなす（編集モードにして、そのまま戻した場合）
            sp = false;
        } else {
            sp = super.isEditingValueChanged(oldValue, newValue, context);
        }
        return sp;
    }

}


/**
 * 
 * コピペは抑止でｋない
 */
export class NoInputEditor extends Spread.Sheets.CellTypes.Base {


    /**
     * 
     * @param context
     */
    createEditorElement(context?: any): HTMLElement {
        return null;
    }

    /**
     * 
     * @param editorContext
     * @param cellStyle
     * @param cellRect
     * @param context
     */
    activateEditor(editorContext: HTMLElement, cellStyle: Spread.Sheets.Style, cellRect: Spread.Sheets.Rect, context?: any): void {
        //noop
    }

    /**
     * Processes key down in display mode.
     * @param {KeyboardEvent} event The KeyboardEvent.
     * @param {Object} context The context associated with the cell type. See the Remarks for more information.
     * @returns {boolean} Returns <c>true</c> if the process is successful; otherwise, <c>false</c>.
     */
    processKeyDown(event: KeyboardEvent, context?: any): boolean {
        //debugger;
        return false;
    }
    /**
     * Processes key up in display mode.
     * @param {KeyboardEvent} event The KeyboardEvent.
     * @param {Object} context The context associated with the cell type. See the Remarks for more information.
     * @returns {boolean} Returns <c>true</c> if the process is successful; otherwise, <c>false</c>.
     */
    processKeyUp(event: KeyboardEvent, context?: any): boolean {
        //debugger;
        return false;
    }
}
